import { useEffect, useRef, useState } from 'react';

import Loader from "../../Assets/Images/loader-dark.gif";

export default function CustomDropdown({
  options = [],
  value = null,
  onChange = () => { },
  placeholder = 'Select Country',
  labelKey = 'label',
  valueKey = 'value',
  label,
  labelStyle,
  searchable = true,
  listClassName,
  loading = false
}) {

  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter((item) =>
    String(item[labelKey] ?? '').toLowerCase().includes(search.toLowerCase())
  );

  // Match by unique value (id), not label — labels can duplicate (e.g. multiple "Mobile wallet")
  const selectedItem = options.find((item) => item[valueKey] === value);

  const handleSelect = (item) => {
    onChange(item);
    setIsOpen(false);
    setSearch('');
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative z-50 e-primary-font e-font-14">
      {/* Trigger */}
      {label &&
        <label className={`${labelStyle} e-primary-font e-text-rich-black e-font-weight-400 line-height-18px e-font-14 padding-6px-bottom`}>
          {label}
        </label>
      }

      <div className="border px-3 padding-12px-tb w-64 bg-white cursor-pointer d-flex justify-content-space-between"
        style={{
          borderColor: isOpen ? '#000000' : '#D7D7D7',
          borderRadius: '8px'
        }}
        onClick={() => setIsOpen(true)}>
        {selectedItem ? (
          <span>{selectedItem[labelKey]}</span>
        ) : (
          <span className="e-primary-font e-font-12 e-font-weight-400 e-text-gray">{placeholder}</span>
        )}
        <img src={require("../../Assets/Images/Home/down-arrow.svg").default}
          alt="dropdown icon"
          className="h-5 w-5" />
      </div>

      {/* Overlay */}
      {isOpen &&
        <div className="e-menu-overlay"
          onClick={() => setIsOpen(false)} />
      }

      {/* Dropdown Panel */}
      {isOpen && (
        <div ref={dropdownRef}
          className="position-absolute mt-2 e-dropdown-wrapper bg-white z-index-99">
          {/* Search Input */}
          {searchable && (
            <div className="px-3 py-2 border-b">
              <input type="text"
                placeholder="Search Country"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="e-search-input"
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '14px',
                }}
              />
            </div>
          )}

          {/* Options List */}
          <ul className={`${listClassName} py-1`}
            style={{
              padding: '8px',
              fontSize: '14px',
            }}>
            {loading ? (
              <li className="px-4 py-2 text-center">
                <img src={Loader}
                  className={`w-20px h-20px margin-2px-block`}
                  alt='loader' />
              </li>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((item) => {
                const isSelected = item[valueKey] === value;

                return (
                  <li key={item[valueKey]}
                    onClick={() => handleSelect(item)}
                    className={`d-flex justify-content-space-between px-3 py-2 cursor-pointer text-black hover:bg-gray-100 rounded-md flex items-center ${isSelected ? 'e-border font-medium' : ''
                      }`}
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: isSelected ? 500 : 400,
                      backgroundColor: 'transparent',
                      fontSize: '14px',
                    }}>
                    <span>{item[labelKey]}</span>
                    {isSelected && (
                      <span className=" ml-auto">
                        <img draggable="false"
                          src={require("../../Assets/Images/Home/tick.svg").default}
                          alt='Selected item' />
                      </span>
                    )}
                  </li>
                );
              })
            ) : (
              <li className="px-4 py-2 e-primary-font e-font-weight-400 e-font-14">No results</li>
            )}

          </ul>
        </div>
      )}
    </div>
  );
}
